export enum HintState {
  none,
  emptyInput,
  notFoundIntervention,
}
